import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/web-coin/web-coin-main.tsx");
